import ModernHeroSection from "components/SectionHero/ModernHeroSection";
import ModernSpacesSection from "components/ModernSpacesSection/ModernSpacesSection";
import ModernHowItWorksSection from "components/ModernHowItWorksSection/ModernHowItWorksSection";
import ModernCategoriesSection from "components/ModernCategoriesSection/ModernCategoriesSection";
import ModernTestimonialsSection from "components/ModernTestimonialsSection/ModernTestimonialsSection";
import ModernServicesSection from "components/ModernServicesSection/ModernServicesSection";
import ModernCallToActionSection from "components/ModernCallToActionSection/ModernCallToActionSection";

import DemoHomePage from "components/DemoHomePage";
import Header2 from "components/Header/Header2";
import LatestBlogPost from "components/LatestBlogPost";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { fetchAllServices } from "redux/features/service/serviceSlice";
import { getAllHomeVideos, getHomeDemoVideos } from "redux/features/Admin/homeVideo/homeVideoSlice";
import "slick-carousel/slick/slick-theme.css";

function PageHome() {
  const dispatch = useAppDispatch();

  const serviceState = useAppSelector((state) => state.service);
  const homeVideoStates = useAppSelector((state) => state.videoHome.allVideos);
  useEffect(() => {
    dispatch(fetchAllServices()); // Fetch real services
    dispatch(getAllHomeVideos());
    dispatch(getHomeDemoVideos());
  }, []);

  return (
    <>
      <Helmet>
        <title>
          Location d’espaces événementiels et salles chez particuliers et professionnels — Paris, Île-de-France et
          partout en France | Event To Bee
        </title>
        <meta
          name="description"
          content="Louez des espaces événementiels et salles chez des particuliers et professionnels, à Paris, en Île-de-France et partout en France. Trouvez le lieu idéal pour tous vos événements."
          title="On simplifie la location de salles à Paris, en Île de France. Trouvez le lieu idéal pour votre événement privé ou professionnel. Réservez facilement sur Event To Bee."
        />
      </Helmet>
      <div className="relative overflow-x-hidden nc-PageHome" style={{ maxWidth: "100vw" }}>
        {/* Modern Hero Section */}
        <ModernHeroSection
          homeVideoUrl={
            homeVideoStates && homeVideoStates[0]?.url
              ? process.env.REACT_APP_CLOUD_FRONT + homeVideoStates[0]?.url
              : ""
          }
        />

        {/* Modern Trending Spaces Section */}
        <ModernSpacesSection />

        {/* Modern How It Works Section */}
        <ModernHowItWorksSection />

        {/* Modern Categories Section */}
        <ModernCategoriesSection />

        <div className="container relative mb-16 space-y-16 lg:space-y-10 lg:mb-20">
          <div className="relative py-4">
            <DemoHomePage />
          </div>
          {/* MODERN SERVICES SECTION */}
        </div>

        <ModernServicesSection services={serviceState.allServices || []} feature={"/prestations?field="} />

        {/* Modern Call To Action Section */}
        <ModernCallToActionSection />

        {/* Modern Testimonials Section */}
        <ModernTestimonialsSection />

        <div className="container relative mb-24 space-y-24 lg:space-y-14 lg:mb-28 mt-20">
          {/* <CallToActionPage /> */}
          <Header2 title={"Devenez Hôte et Proposez Votre Espace !"} url={"/add/location"} />
        </div>
        {/* VIDEO SECTION */}
        {/* <SectionVideos />   */}
        {/* <Header3 />
          <Slider /> */}
      </div>
      <div className="pt-12">
        <LatestBlogPost />
      </div>
    </>
  );
}

export default PageHome;
